import type { RefObject } from 'react';
import { useState, useEffect, useMemo } from 'react';
import { useIsClient } from '@alfa-bank/site-helpers-common/browser/use-is-client';

import type { TPanelHeaderDesktopV2Props } from '../../models';

export const useTabsPanelV2Width = ({
    headerList,
    widthTab,
}: {
    headerList: RefObject<HTMLDivElement>;
    widthTab: TPanelHeaderDesktopV2Props['widthTab'];
}) => {
    const [biggerTabWidth, setBiggerTabWidth] = useState<undefined | number>(undefined);
    const isClient = useIsClient();

    const tabWidthList: number[] = useMemo(() => [], []);

    useEffect(() => {
        if (isClient && headerList.current?.children.length && widthTab === 'equal') {
            for (let i = 1; headerList.current?.children.length > i; i++) {
                if (headerList.current.children[i].role === 'tab') {
                    tabWidthList.push(headerList.current.children[i].getBoundingClientRect().width);
                }
            }
        }
    }, [isClient, headerList, tabWidthList, widthTab]);

    useEffect(() => {
        if (isClient) {
            setBiggerTabWidth(tabWidthList.sort((a, b) => b - a)[0]);
        }
    }, [isClient, biggerTabWidth, tabWidthList]);

    return { biggerTabWidth };
};
